<div class="flex-login-container">
  <div class="login-panel clearfix">
    <div class="login-container">
      <div class="login-form-panel">
        @if (!complete) {
          <div class="contents">
            @if (loading) {
              <div class="page-loading">
                <span>
                  <span></span>
                </span>
              </div>
            }
            <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()">
              <div class="selector">
                <div class="row">
                  <div class="small-12">
                    <label for="email">Email:
                      <input type="email" id="email" formControlName="email" placeholder="Email"
                        autocomplete="email" required />
                    </label>
                    @if (form.get('email').invalid && form.get('email').touched) {
                      <div>
                        @if (form.get('email').errors.required) {
                          <small style="display: block;">Email
                          is required.</small>
                        }
                        @if (form.get('email').errors.email) {
                          <small style="display: block;">Invalid
                          email format.</small>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
              <div class="selector">
                <div class="row">
                  <div class="small-12">
                    <label for="employeeNumber">Employee number:
                      <input type="text" id="employeeNumber" formControlName="employeeNumber"
                        placeholder="Employee number" required />
                    </label>
                    @if (form.get('employeeNumber').invalid && form.get('employeeNumber').touched) {
                      <div
                        >
                        @if (form.get('employeeNumber').errors.required) {
                          <small
                            style="display: block;">Employee number is
                          required.</small>
                        }
                        @if (form.get('employeeNumber').errors.minlength) {
                          <small
                            style="display: block;">Employee number
                            must
                          be at least 8 characters long.</small>
                        }
                        @if (form.get('employeeNumber').errors.numeric) {
                          <small
                            style="display: block;">Employee number
                            must be
                          a number.</small>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
              <button [disabled]="form.invalid" type="submit">
                Submit
              </button>
              @if (showError) {
                <small class="error-message" style="display: block;">{{ errorMessage
                }}</small>
              }
            </form>
          </div>
        }
        @if (complete) {
          <div class="contents">
            <p>
              An email has been sent to {{ emailAddress }} with instructions
              on resetting your password. Please check your Spam/Junk folders in
              case the email has been sent there. The link on the reset email is
              valid for 24hrs, after this time you will need to request another
              password reset.
            </p>
          </div>
        }
      </div>
      <div class="register-panel">
        <div class="contents">
          <h2>Having trouble logging in?</h2>
          <div class="text-container main-text">
            <p>Fill in your details to reset your password.</p>
          </div>
          <div class="text-container">
            <p class="bottom-text">
              Already registered?
              <button class="button button-green" [routerLink]="['/Login']">
                Sign in now
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>